import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-surface-app">
                <div className="animate-pulse font-heading text-lg text-brand-blue">
                    Lade...
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/heute" replace />;
    return children;
}
